import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  DialogActions,
  Slide
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import WarningIcon from '@material-ui/icons/Warning'
import { useStyles } from './Styles'
import { FormLoader } from '../../../../Loader/FormLoader'
import { useKeycloak } from '@react-keycloak/web'
import SubscriptionServices from '../../../../../Services/Consumers/SubscriptionServices'

const Transition = React.forwardRef(function Transition (props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const DeletePromocode = ({
                          index, data, setData, count, setCount, handleNotificationCall,
                          handleDeletePromocodeDialog, viewDeletePromocodeDialog, openDeletePromocodeDialog
                        }) => {
  const classes = useStyles()
  const intl = useIntl()
  const { keycloak } = useKeycloak()
  const [deleteLoading, setDeleteLoading] = React.useState(false)

  const handleDelete = async () => {
    setDeleteLoading(true)
    
    try {
      const result = await SubscriptionServices.deletePromocode(
        data[index].id,
        { headers: { 'Authorization': `Bearer ${keycloak?.token ?? ''}` } },
        setDeleteLoading
      )
      
      if (result && result.status === 200) {
        handleNotificationCall({
          type: 'defence',
          message: intl.formatMessage({ id: 'Promocode.SuccessDelete' }),
          color: 'success'
        }, 'success')
        
        // Update the data
        let newData = [...data]
        newData.splice(index, 1)
        setData(newData)
        setCount(count - 1)
        handleDeletePromocodeDialog()
      } else {
        handleNotificationCall({
          type: 'defence',
          message: intl.formatMessage({ id: 'BasicInfo.FormErrorAlert' }),
          color: 'error'
        }, 'error')
      }
    } catch (error) {
      handleNotificationCall({
        type: 'defence',
        message: intl.formatMessage({ id: 'BasicInfo.FormErrorAlert' }),
        color: 'error'
      }, 'error')
    } finally {
      setDeleteLoading(false)
    }
  }

  return (
    <>
      {!!viewDeletePromocodeDialog &&
      <Dialog
        keepMounted
        fullWidth
        maxWidth={'sm'}
        open={openDeletePromocodeDialog}
        classes={{ paper: classes.NewOrderDialogPaper }}
        TransitionComponent={Transition}
        onClose={handleDeletePromocodeDialog}
        aria-labelledby="BasicInfoDialog"
        aria-describedby="BasicInfoDialog"
      >
        <IconButton
          edge={false}
          className={classes.NewOrderDialogClose}
          color="inherit"
          aria-label="close dialog"
          onClick={handleDeletePromocodeDialog}
        >
          <CloseIcon/>
        </IconButton>
        <DialogContent className={classes.NewOrderDialogContent}>
          {!!deleteLoading && <FormLoader loading={true}/>}
          <Box px={4} pt={4} pb={1} className={classes.DeleteOrderWrapper}>
            <WarningIcon className={classes.DeleteWarningIcon}/>
            <p>{intl.formatMessage({ id: 'Promocode.DeleteConfirmation' }, { title: data[index].title, code: data[index].code })}</p>
          </Box>
        </DialogContent>
        <DialogActions className={classes.NewOrderDialogFooter}>
          <Button size="large" variant="contained" color="primary" className={classes.DeleteOrderBtn}
                  onClick={handleDelete}>
            <FormattedMessage id='Page.Action.Delete'/>
          </Button>
          <Button onClick={handleDeletePromocodeDialog} color="primary">
            <FormattedMessage id='ChangePhone.DialogActions.cancel'/>
          </Button>
        </DialogActions>
      </Dialog>
      }
    </>
  )
}

export default DeletePromocode

